var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrival(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrival",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36397",
    "data-name": "Group 36397"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8197",
    "data-name": "Rectangle 8197",
    width: 16,
    height: 16,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36398",
    "data-name": "Group 36398",
    transform: "translate(1.333 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40763",
    "data-name": "Path 40763",
    d: "M8,5.667,7.067,6.6,8.8,8.333H2V9.667H8.8L7.067,11.4,8,12.333,11.333,9Zm6,8H8.667V15H14a1.337,1.337,0,0,0,1.333-1.333V4.333A1.337,1.337,0,0,0,14,3H8.667V4.333H14Z",
    transform: "translate(-2 -3)",
    fill: "#555"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrival);
export default __webpack_public_path__ + "static/media/arrival.df72af1a2518a28d414bac9f208dfd76.svg";
export { ForwardRef as ReactComponent };